import React, { Component } from 'react'
import { Authenticator } from './Authenticator'
import { isAuth, registerLogout } from '../../utils/AuthUtill'

type Props = {};
type State = { signedIn: any };
export const withAuthenticator = (Comp: any) => {
    return class extends Component<Props, State> {
        constructor (props: any) {
            super(props)
            this.state = {
                signedIn: isAuth()
            }
            registerLogout(this.handleAuthStateChange)
        }

        handleAuthStateChange = (state: any) => {
            this.setState({ signedIn: state })
        }

        render () {
            let { signedIn } = this.state;
            if (signedIn) {
                return (
                    <Comp
                        {...this.props}
                    />
                )
            }

            return <Authenticator
                onStateChange={this.handleAuthStateChange}
            />
        }
    }
}
